/**
 * useCommunityRitualistsInfinite Hook
 * Fetches community ritualists (members with RITUALIST role) with infinite scroll using React Query
 */

import { useInfiniteQuery } from "@tanstack/react-query"
import { PAGINATION } from "@/constants/constants"
import { getCommunityMembers } from "../services/community.service"

interface UseCommunityRitualistsInfiniteParams {
  communityId: string
  highlighted?: boolean
  searchQuery?: string
}

export function useCommunityRitualistsInfinite({
  communityId,
  highlighted,
  searchQuery,
}: UseCommunityRitualistsInfiniteParams) {
  return useInfiniteQuery({
    queryKey: ["communityRitualists", communityId, highlighted, searchQuery],
    queryFn: ({ pageParam = PAGINATION.DEFAULT_PAGE }) =>
      getCommunityMembers(communityId, {
        page: pageParam,
        limit: PAGINATION.MEMBER_LIST_LIMIT,
        role: "ritualist",
        highlighted: highlighted === true, // Explicit boolean to ensure distinct query keys
        search: searchQuery || undefined,
      }),
    initialPageParam: 1,
    getNextPageParam: lastPage =>
      lastPage.pagination.hasMore ? lastPage.pagination.page + 1 : undefined,
    enabled: !!communityId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}
